<template>
  <div class="layout-container">
    <div class="layout-page">
      <Nav></Nav>
      <div class="content-wrapper">
        <div class="container-xxl flex-grow-1 container-p-y">
          
          <b-overlay :show="show" rounded="sm" opacity="0.5">
            
            <!-- 1. الداش بورد العلوي (تصميم عصري) -->
            <!-- <div class="row mb-4 g-3 no-print">
              <div v-for="(stat, index) in dashboardStats" :key="index" class="col-lg-3 col-md-6">
                <div :class="['card border-0 shadow-sm dashboard-card', stat.bgClass]">
                  <div class="card-body d-flex align-items-center justify-content-between">
                    <div class="text-white">
                      <p class="mb-1 opacity-75 small fw-bold">{{ stat.label }}</p>
                      <h3 class="fw-bold mb-0">{{ stat.value }} <small class="fs-6">{{ stat.unit }}</small></h3>
                    </div>
                    <div class="dash-icon-bg shadow-sm">
                      <i :class="['bx fs-1 text-white', stat.icon]"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <!-- 2. شبكة الأيقونات الاحترافية (تكرار ذكي) -->
            <div class="row g-4 justify-content-center">
              <template v-for="(item, index) in menuItems">
                <div 
                  v-if="admin[item.permission]" 
                  :key="index" 
                  class="col-6 col-sm-4 col-md-3 col-lg-2"
                >
                  <router-link :to="item.route" class="text-decoration-none">
                    <div class="card h-100 pro-menu-card border-0 shadow-sm">
                      <div class="card-body d-flex flex-column align-items-center justify-content-center py-4">
                        <div :class="['icon-box mb-3 rounded-circle shadow-sm', item.colorClass]">
                          <i :class="['bx fs-1', item.icon]"></i>
                        </div>
                        <h6 class="text-dark fw-bold mb-0 text-center">{{ item.name }}</h6>
                      </div>
                    </div>
                  </router-link>
                </div>
              </template>
            </div>

            <!-- 3. شريط التنبيهات السريع (CSS Marquee - لا يسبب بطء) -->
 <div class="marquee-fixed no-print" v-if="count.length > 0">
  <div class="marquee-title">تنبيهات</div>
  <div class="marquee-scroll-container">
    <div class="marquee-text-flow">
      <!-- الجزء الأول -->
      <span v-for="(c, index) in count" :key="index" class="marquee-msg">
        <i class="bx bx-bell-plus"></i> {{ c }}
      </span>
      <!-- الجزء الثاني للتكرار المستمر -->
      <span v-for="(c, index) in count" :key="'copy-'+index" class="marquee-msg">
        <i class="bx bx-bell-plus"></i> {{ c }}
      </span>
    </div>
  </div>
</div>

          </b-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/layout/Nav.vue";
import Api from '@/apis/Api';

export default {
  components: { Nav },
  data() {
    return {
      count: [],
      show: false,
      dashboardStats: [
        { label: 'إنتاجية المواقع', value: '0', unit: 'M³', icon: 'bx-trending-up', bgClass: 'bg-primary-grad' },
        { label: 'الأسطول النشط', value: '0', unit: 'معدة', icon: 'bx-bus-school', bgClass: 'bg-success-grad' },
        { label: 'الأعطال اليومية', value: '0', unit: 'بلاغ', icon: 'bx-error-circle', bgClass: 'bg-danger-grad' },
        { label: 'طلبات معلقة', value: '0', unit: 'طلب', icon: 'bx-time-five', bgClass: 'bg-warning-grad' }
      ],
      // قائمة الأيقونات المحترفة (BoxIcons بدلاً من الصور)
      menuItems: [
        // { name: 'الجراج', route: 'Garage', icon: 'bx-car', permission: 'garage', colorClass: 'icon-orange' },
        { name: 'المواقع', route: 'UserSite', icon: 'bx-map-alt', permission: 'site_code', colorClass: 'icon-blue' },
        { name: 'المعدات والسيارات', route: 'HomePage', icon: 'bx-hard-hat', permission: 'car', colorClass: 'icon-indigo' },
        { name: 'العاملين', route: 'SearchEmployees', icon: 'bx-group', permission: 'hr', colorClass: 'icon-green' },
        { name: 'المخزن', route: 'Warehouse_Management', icon: 'bx-package', permission: 'maint', colorClass: 'icon-red' },
        { name: 'التشغيل', route: 'QuickWeeklyOperationMatrix', icon: 'bx-task', permission: 'operation', colorClass: 'icon-purple' },
        { name: 'الموردين', route: 'HomePage', icon: 'bx-user-voice', permission: 'vendor', colorClass: 'icon-cyan' },
        { name: 'التقارير', route: 'Reports', icon: 'bx-bar-chart-square', permission: 'report', colorClass: 'icon-dark' },
        { name: 'طلبات المواقع', route: 'HomePage', icon: 'bx-spreadsheet', permission: 'order_site', colorClass: 'icon-blue' },
        { name: 'المستخدمين', route: 'HomePage', icon: 'bx-user-circle', permission: 'users', colorClass: 'icon-indigo' },
        { name: 'الضبط العام', route: 'Settings', icon: 'bx-slider-alt', permission: 'settings', colorClass: 'icon-gray' },
        { name: 'الحسابات', route: 'Acounting', icon: 'bx-calculator', permission: 'settings', colorClass: 'icon-orange' },
        { name: 'التوريدات', route: 'Supply', icon: 'bx-export', permission: 'accounts', colorClass: 'icon-blue' },
        { name: 'تصفية الموردين', route: 'Suppliers', icon: 'bx-money-withdraw', permission: 'supply', colorClass: 'icon-green' },
        { name: 'الخزنة', route: 'moveUnapprove', icon: 'bx-buildings', permission: 'sub_safe', colorClass: 'icon-success' },
        { name: 'المصاريف', route: 'SiteExpense', icon: 'bx-money', permission: 'sub_safe', colorClass: 'icon-primary' },
        // { name: 'تقييم العاملين', route: 'Rating', icon: 'bx-star', permission: 'message', colorClass: 'icon-warning' },
        // { name: 'إشعارات واردة', route: 'NOTIFICATIONS', icon: 'bx-bell-plus', permission: 'admin', colorClass: 'icon-red' },
        { name: 'المطبوعات', route: 'PrintPage', icon: 'bx-printer', permission: 'admin', colorClass: 'icon-dark' }
      ]
    }
  },
  computed: {
    admin() { return this.$store.getters.get_user; }
  },
  created() {
    this.$store.dispatch("SetData");
  },
  mounted() {
    document.getElementsByTagName("html")[0].classList.remove('layout-menu-expanded');
    Api.get('count_message').then(res => { this.count = res.data });
  }
}
</script>

<style scoped>
/* 1. تصميم الداش بورد */
.dashboard-card { border-radius: 12px !important; overflow: hidden; position: relative; }
.bg-primary-grad { background: linear-gradient(to right, #696cff, #8e91ff); }
.bg-success-grad { background: linear-gradient(to right, #71dd37, #96eb69); }
.bg-danger-grad  { background: linear-gradient(to right, #ff3e1d, #ff715a); }
.bg-warning-grad { background: linear-gradient(to right, #ffab00, #ffc44d); }

.dash-icon-bg { background: rgba(255, 255, 255, 0.2); padding: 12px; border-radius: 10px; }

/* 2. تصميم الأيقونات المحترفة */
.pro-menu-card {
  border-radius: 15px !important;
  transition: all 0.25s ease-in-out;
  border: 1px solid #f0f0f0 !important;
}
.pro-menu-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(105, 108, 255, 0.15) !important;
  border-color: #696cff !important;
}

.icon-box {
  width: 65px; height: 65px;
  display: flex; align-items: center; justify-content: center;
  transition: 0.3s;
}

/* باليت الألوان الاحترافية للأيقونات */
.icon-orange  { background: #fff4e0; color: #ffab00; }
.icon-blue    { background: #e7f7ff; color: #03c3ec; }
.icon-indigo  { background: #e8eaff; color: #696cff; }
.icon-green   { background: #e8fadf; color: #71dd37; }
.icon-red     { background: #ffebeb; color: #ff3e1d; }
.icon-purple  { background: #f2eaff; color: #8592a3; }
.icon-cyan    { background: #d7f5fc; color: #00cfd5; }
.icon-dark    { background: #ecedef; color: #233446; }
.icon-gray    { background: #f0f2f4; color: #8592a3; }

/* 3. شريط الأخبار اليدوي (High Performance) */
.marquee-fixed {
  position: fixed; bottom: 0; left: 0; width: 100%; height: 45px;
  background: #233446; display: flex; align-items: center; z-index: 999;
  border-top: 3px solid #696cff; overflow: hidden;
}
.marquee-title {
  background: #696cff; color: white; padding: 0 20px; line-height: 45px;
  font-weight: bold; position: relative; z-index: 10;
}
.marquee-scroll-container { flex: 1; overflow: hidden; }
.marquee-text-flow {
  display: inline-block; white-space: nowrap;
  animation: marquee-move 30s linear infinite;
}
.marquee-msg { color: white; padding: 0 40px; font-size: 0.95rem; }

@keyframes marquee-move {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
.marquee-scroll-container {
  overflow: hidden;
  width: 100%;
  direction: ltr; /* نجعل الاتجاه من اليسار لليمين للحاوية */
}

/* الحاوية التي تحتوي على النص وتتحرك */
.marquee-text-flow {
  display: flex;
  width: max-content; /* لضمان أن العرض يتناسب مع محتوى النصوص */
  animation: scroll-left-to-right 30s linear infinite; /* استدعاء الحركة */
}

/* تعريف الحركة من اليسار إلى اليمين */
@keyframes scroll-left-to-right {
  0% {
    transform: translateX(-50%); /* يبدأ من إزاحة سالبة (اليسار) */
  }
  100% {
    transform: translateX(0); /* ينتهي عند نقطة الصفر (اليمين) */
  }
}

/* تنسيق الرسالة الواحدة */
.marquee-msg {
  padding: 0 20px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  direction: rtl; /* لكي يظل النص العربي داخل الرسالة مرتباً بشكل صحيح */
}

/* أيقونة التنبيه */
.marquee-msg i {
  margin-left: 8px; /* مسافة بين الأيقونة والنص */
}
h6 { font-size: 0.85rem; letter-spacing: -0.2px; }
</style>